module.exports = __webpack_public_path__ + "img/fd_coupon_img.dff0898c.png";